import { DateTime } from 'luxon'
import Holidays from 'date-holidays'
import { Market } from 'types/Market'

type PrizeDayInfo = {
  start: Date
  end: string | Date
  isHoliday: boolean
  isWeekend: boolean
}

export function getPrizeDaysInfo(market: Market): PrizeDayInfo[] {
  const holidays = new Holidays(market.code)
  const days = [] as PrizeDayInfo[]

  // const tz = market.timeZone // np. 'Europe/Warsaw'

  const startDate = DateTime.fromJSDate(new Date(market.promoLiveDate))
  const endDate = DateTime.fromJSDate(new Date(market.promoEndDate))
  let currentDate = startDate

  while (currentDate <= endDate.endOf('day')) {
    const isLastDay = currentDate.hasSame(endDate, 'day')
    const jsDate = currentDate.toJSDate()
    const isWeekend = currentDate.weekday === 6 || currentDate.weekday === 7 // sobota/niedziela w luxon

    const isHoliday = holidays.isHoliday(jsDate)

    days.push({
      start: currentDate.toJSDate(),
      end: isLastDay ? market.promoEndDate : currentDate.endOf('day').toJSDate(),
      isHoliday: Array.isArray(isHoliday) && isHoliday.every(el => el.type === 'public'),
      isWeekend,
    })

    currentDate = currentDate.plus({ days: 1 })
  }

  return days
}
